import {
  IModifyParamsToSend,
  IParamsToSend
} from '@base/@types/providers/Otb/PlanProvider'

export const paramsToSendMapping = ({
  name,
  values,
  fieldName,
  compareName,
  paramsToSend
}: IModifyParamsToSend) => {
  const newParamsToSend: IParamsToSend = { ...paramsToSend }

  if (name === 'periodoSelectIds') {
    newParamsToSend.periodo = {
      mes: values[0].mes,
      ano: values[0].ano,
      descricao: ''
    }

    return newParamsToSend
  }

  if (name === compareName) {
    newParamsToSend[fieldName] = values.map(value => value.value as number)
  }

  return newParamsToSend
}
